import React, { useEffect, useMemo, useState } from 'react';
import InventoryTablePage from '../components/inventory/InventoryTablePage';
import { productsApi } from '../services/api';

function formatDate(value) {
    if (!value) return '-';
    return new Date(value).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function ExpiredProductsPage() {
    const [products, setProducts] = useState([]);
    const [summary, setSummary] = useState({ total_products: 0, total_quantity: 0, total_stock_value: 0 });

    const loadProducts = () => {
        productsApi.expired().then((res) => {
            const rows = (res?.data || []).map((item) => ({
                id: item.id,
                sku: item.sku,
                productName: item.name,
                createdOn: formatDate(item.created_at),
                expiredDate: formatDate(item.expiry_date),
                daysExpired: item.days_expired ?? 0,
                expiredQty: item.expired_quantity ?? item.quantity_in_stock ?? 0,
                stockValue: Number(item.expired_stock_value || 0),
                category: item.category || '-',
                icon: (item.name || '?').slice(0, 1).toUpperCase(),
            }));
            setProducts(rows);
            setSummary(res?.summary || { total_products: rows.length, total_quantity: 0, total_stock_value: 0 });
        });
    };

    useEffect(() => {
        loadProducts();
    }, []);

    const columns = useMemo(() => [
        { key: 'sku', label: 'SKU' },
        {
            key: 'productName',
            label: 'Product Name',
            render: (row) => (
                <div className="product-name-cell compact">
                    <div className="product-thumb">{row.icon}</div>
                    <strong>{row.productName}</strong>
                </div>
            ),
        },
        { key: 'category', label: 'Category' },
        { key: 'expiredQty', label: 'Expired Qty' },
        { key: 'daysExpired', label: 'Days Expired' },
        { key: 'stockValue', label: 'Stock Value', render: (row) => `₦${Number(row.stockValue || 0).toLocaleString('en-NG')}` },
        { key: 'createdOn', label: 'Created On' },
        { key: 'expiredDate', label: 'Expired Date' },
    ], []);

    const exportCsv = () => {
        const header = ['SKU', 'Product Name', 'Category', 'Expired Qty', 'Days Expired', 'Stock Value', 'Created On', 'Expired Date'];
        const lines = products.map((item) => [item.sku, item.productName, item.category, item.expiredQty, item.daysExpired, item.stockValue, item.createdOn, item.expiredDate]);
        const csv = [header, ...lines].map((line) => line.map((value) => `"${String(value || '').replace(/"/g, '""')}"`).join(',')).join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'expired-products.csv';
        link.click();
        URL.revokeObjectURL(url);
    };

    const filterOptions = (
        <div className="inventory-summary-strip">
            <span>{summary.total_products || 0} expired products</span>
            <span>{summary.total_quantity || 0} units affected</span>
            <span>₦{Number(summary.total_stock_value || 0).toLocaleString('en-NG')} stock value</span>
        </div>
    );

    return <InventoryTablePage title="Expired Products" breadcrumb="Expired Products" rows={products} columns={columns} filterOptions={filterOptions} toolbarButtons={<><button className="mini-icon-btn" type="button" onClick={loadProducts}>↻</button><button className="btn" type="button" onClick={exportCsv}>Export Expired</button></>} />;
}
